import Vue from "vue";
//import store from "@/app/app-state";
import RestClient from "./restClient";
import { apiUrls, tesfriConfigurationsecureKey, clientEnvironmentCode } from "@/environment/environment";

const urlApiHelper = class {
  async setUrlAuthFromApi(userinfo) {
    // recuperation des droits de l'API
    let tesfriconfigurationAPI = apiUrls.tesfriconfiguration;

    this.restClient = new RestClient(tesfriconfigurationAPI).Instance;
    await this.restClient
      .get(
        `/Configurations/Anonymous/ByCodes?companyCode=${userinfo.company}&warehouseCode=${userinfo.warehouse}&environmentCode=${clientEnvironmentCode}&configurationType=AuthApi&secureKey=${tesfriConfigurationsecureKey}`
      )
      .then(response => {
        if (response.status == 200) {
          apiUrls.auth = response.data;
        }
      })
      .catch(error => {
        Vue.$log.error(error);
      });
  }
};

export default new urlApiHelper();
